import axios from 'axios'
import store from '../../store'
const baseUrl = () => store.state.parantion.baseUrl

export async function pollForReports (context, payload) {
  return axios
    .get(baseUrl() + '/v51/file', {
      params: {
        foh: payload.folderHash,
        uh: payload.uh
      }
    })
    .then(res => {
      return res.data.file.find(file => {
        const dt = file.label === payload.reportLabel && file.foh === payload.folderHash && new Date(file.create_date)
        // if a new file with the same name was found, and created in the last 10 minutes, that means it's probably the file we are looking for.
        if (dt && new Date().getTime() - dt.getTime() < 1000 * 60 * 10) {
          return true
        } else return false
      })
    })
}
